import { FileActionsMenuItem } from "./FileActionsMenu.types";

const PDF_CONTENT_TYPE = "application/pdf";

export function isPdfContentType(contentType: string): boolean {
  return contentType.toLowerCase() === PDF_CONTENT_TYPE;
}

/**
 * Places the row-specific actions in the list of standard actions: an item with an index takes that
 * position in the menu, an item without one lands after the standard actions. Out-of-range indexes
 * fall back to the end of the list.
 */
export function insertFileActionItems(
  standardItems: FileActionsMenuItem[],
  extraItems: FileActionsMenuItem[]
): FileActionsMenuItem[] {
  const items = [...standardItems];

  for (const item of extraItems) {
    const position = Math.min(Math.max(item.index ?? items.length, 0), items.length);
    items.splice(position, 0, item);
  }

  return items;
}
